import {
  Alert,
  Box,
  Button,
  Container,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { arrayUnion } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllData, updateDocument } from "../../Utils/firebaseServices";

const Login = () => {
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = React.useState({ error: false, msg: "" });

  useEffect(() => {
    const auth = localStorage.getItem("admin");
    const crm_user_auth = localStorage.getItem("crm_user");

    if (auth) {
      navigate("/dashboard");
    } else if (crm_user_auth) {
      navigate("/crm/dashboard");
    } else {
      navigate(window.location.pathname);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (email && password) {
      if (window.location.pathname === "/crm") {
        try {
          const empData = async (res) => {
            let empList = res;
            let isValidemp = false;
            let matchedemp = null;

            empList.forEach((doc) => {
              if (doc.email === email && doc.password === password) {
                isValidemp = true;
                matchedemp = doc;
              }
            });
            if (isValidemp && matchedemp) {
              const currentDateTime = new Date().toLocaleString();
              await updateDocument("financeUserPortal", matchedemp.id, {
                loginStatus: arrayUnion({ date: currentDateTime }),
              });
              alert("Login successful!");
              setMessage({ error: false, msg: "Login successful!" });
              localStorage.setItem("crm_user", JSON.stringify(matchedemp));
              navigate("/crm/dashboard");
            } else {
              setMessage({ error: false, msg: "Invalid email or password." });
            }
          };

          await getAllData("financeUserPortal", empData);
        } catch (error) {
          console.error("Login error:", error.message);
          setMessage({ error: false, msg: "Login failed! Please try again." });
        }
      } else {
        try {
          const userData = async (res) => {
            let adminList = res;
            let isValidAdmin = false;
            let matchedAdmin = null;

            adminList.forEach((doc) => {
              if (doc.userName === email && doc.password === password) {
                isValidAdmin = true;
                matchedAdmin = doc;
              }
            });
            if (isValidAdmin && matchedAdmin) {
              const currentDateTime = new Date().toLocaleString();
              await updateDocument("admin_user", matchedAdmin.id, {
                loginStatus: arrayUnion({ date: currentDateTime }),
              });
              alert("Login successful!");
              setMessage({ error: false, msg: "Login successful!" });
              localStorage.setItem("admin", JSON.stringify(matchedAdmin));
              navigate("/dashboard");
            } else {
              setMessage({ error: false, msg: "Invalid email or password." });
            }
          };

          await getAllData("admin_user", userData);
        } catch (error) {
          console.error("Login error:", error.message);
          setMessage({ error: false, msg: "Login failed! Please try again." });
        }
      }
    } else {
      setMessage({ error: false, msg: "All fields are mandatory!" });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: 3,
            boxShadow: 3,
            borderRadius: 2,
            bgcolor: "background.paper",
          }}
        >
          {message?.msg && (
            <Alert
              severity={message?.error ? "success" : "error"}
              onClose={() => setMessage("")}
              sx={{ width: "100%", mb: 2 }}
            >
              {message?.msg}
            </Alert>
          )}
          <Typography variant="h5" component="h1" gutterBottom>
            Log In
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ mt: 1, width: "100%" }}
          >
            <TextField
              fullWidth
              label="Email address"
              type="email"
              variant="outlined"
              margin="normal"
              placeholder="Enter email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              variant="outlined"
              margin="normal"
              placeholder="Enter password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 3, mb: 2 }}
            >
              Submit
            </Button>
            <Typography align="right" variant="body2">
              Forgot{" "}
              <Link href="#" underline="hover">
                password?
              </Link>
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
export default Login;
